<template>
  <div>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="deleteMetro">
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    deleteMetro: function() {
      this.params.context.componentParent.deleteMetro(this.params.data);
    }
  }
};
</script>